module.exports = __webpack_public_path__ + "static/media/Facebook.28e4cb76.svg";